module.exports = __webpack_public_path__ + "img/crash.86d45523.webp";